import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { useEffect, useMemo } from 'react';
import { getAccountDashboardUrl } from 'self-service-api/core/utilities/links';
import { getTrackingProperties, track } from '../../../utils/usageTracker';
import { ErrorBoundary, ErrorBoundaryNames } from '../../ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
const ViewAccountButtonBase = ({
  'data-selenium-id': dataSeleniumId,
  'data-test-id': dataTestId,
  apiName,
  level,
  children,
  trackingData,
  upgradeConfig,
  uiButtonProps,
  onClick
}) => {
  const trackingProperties = useMemo(() => getTrackingProperties({
    apiName,
    trackingData,
    upgradeConfig,
    sourceKey: 'VIEW_ACCOUNT'
  }), [apiName, trackingData, upgradeConfig]);
  useEffect(() => {
    track('interaction', Object.assign({
      action: 'viewed view account'
    }, trackingProperties, {
      isPrimaryCta: level === 0,
      isSecondaryCta: level === 1
    }));
  }, [trackingProperties, level]);
  const handleClick = () => {
    onClick === null || onClick === void 0 || onClick('VIEW_ACCOUNT');
    track('external-link-click', {
      name: 'account-summary',
      trackingSource: trackingData.source
    });
  };
  return /*#__PURE__*/_jsx(Button, Object.assign({
    "data-selenium-id": dataSeleniumId,
    "data-test-id": dataTestId,
    href: getAccountDashboardUrl(),
    target: "_blank",
    truncate: true,
    truncateStringProps: {
      justifyContent: 'center'
    },
    onClick: handleClick
  }, uiButtonProps, {
    children: children !== null && children !== void 0 ? children : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "purchaseMotions.buttons.viewAccount"
    })
  }));
};
export const ViewAccountButton = props => /*#__PURE__*/_jsx(ErrorBoundary, {
  boundaryName: ErrorBoundaryNames.VIEW_ACCOUNT_BUTTON,
  children: /*#__PURE__*/_jsx(ViewAccountButtonBase, Object.assign({}, props))
});